import React from "react";
import { RichText } from "prismic-reactjs";

const ArticleSection = ({ articleSections }) => {
  const items = articleSections.items || [];
  return (
    <section className="gradient-light">
      <div className="container px-0 py-lg-4 article-container">
        <div className="d-flex flex-wrap-sm mt-5 articles">
          {items.map((item, index) => (
            <div className="" key={index}>
              <div className="card">
                <div className="card-imgs">
                <img
                  src={item.article_image.url}
                  alt={item.article_image.alt || "Article Image"}
                />
                </div>
                <div className="card-body card-body-width px-0 mx-auto">
                  <h5 className="card-title text-left font-gbold">
                    <RichText render={item.article_title} />
                  </h5>
                  <p className="font-qregular card-text text-left mt-2">
                    <RichText render={item.article_description} />
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ArticleSection;